import { NavLink, ThemeIcon } from '@mantine/core';
import { IconBuilding } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums/routes';

interface CompanyLinkProps {
  navigate(route: string): void;
}

export function CompanyLink({ navigate }: CompanyLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: '#373A40',
        },
      }}
      label="Empresas"
      fw="bold"
      color=""
      icon={
        <ThemeIcon color="red" variant="light">
          <IconBuilding size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="Cadastro"
        onClick={() => navigate(AppRoutePaths.COMPANIES_CREATE)}
      />
      <NavLink
        label="Lista"
        onClick={() => navigate(AppRoutePaths.COMPANIES)}
      />
    </NavLink>
  );
}
